export default function BeardTab({ tab, id, title, count, countActive, onSelect }) {
    const formattedCount = count > 99 ? '99' : count
    return (
        <li>
            <a role="button" className={cn(tab === id && "active")} onClick={() => onSelect(id)}>{title} {count > 0 && <i className={cn(countActive && 'active')}>{formattedCount}</i>}</a>
        </li>
    )
}
